import { QueryClient } from '@tanstack/react-query'
import type { QueryClientConfig } from '@tanstack/react-query'

import { defaultQueryOptions } from './defaultOptions'

const mergeDefaultOptions = (
  baseOptions: QueryClientConfig['defaultOptions'] = {},
  overrideOptions: QueryClientConfig['defaultOptions'] = {}
): QueryClientConfig['defaultOptions'] => {
  return {
    queries: {
      ...baseOptions.queries,
      ...overrideOptions.queries,
    },
    mutations: {
      ...baseOptions.mutations,
      ...overrideOptions.mutations,
    },
  }
}

export const createQueryClient = (config: QueryClientConfig = {}) => {
  const mergedDefaultOptions = mergeDefaultOptions(defaultQueryOptions, config.defaultOptions)

  return new QueryClient({
    ...config,
    defaultOptions: mergedDefaultOptions,
  })
}
